import * as types from './mutation-types'

export default {
  [types.UPDATE_EVENT] (state, result) {
    Object.assign(state, result)
  }
}



// WEBPACK FOOTER //
// ./src/store/eventList/mutations.js